export const removeLastItemArray = (array) => {
    if (array.length > 1) {
        return array.slice(0, -1);
    } else {
        return [];
    }
};
